<!-- Nothing to show while presence is unknown or the fund has no ops contacts. -->
<div class="ops-presence" *ngIf="isLoading || contacts.length">
  <div class="ops-cluster ops-cluster--loading" *ngIf="isLoading">
    <ngx-skeleton-loader
      *ngFor="let item of [1, 2, 3]"
      count="1"
      appearance="circle"
      [theme]="{
        width: '32px',
        height: '32px',
        margin: 0
      }"></ngx-skeleton-loader>
  </div>

  <button
    *ngIf="!isLoading"
    type="button"
    class="ops-cluster"
    [matMenuTriggerFor]="opsMenu"
    (menuClosed)="onMenuClosed()"
    [matTooltip]="'Ops team — ' + availabilitySummary"
    matTooltipPosition="below"
    [attr.aria-label]="'Ops team, ' + availabilitySummary">
    <span
      class="ops-bubble"
      *ngFor="let contact of visibleContacts; trackBy: trackById"
      [class.ops-bubble--muted]="contact.status === 'off'">
      <img
        *ngIf="contact.avatarUrl"
        class="ops-bubble__img"
        [appAvatarImage]="contact.avatarUrl"
        [src]="contact.avatarUrl"
        [alt]="contact.name" />
      <span *ngIf="!contact.avatarUrl" class="ops-bubble__initials">
        {{ initials(contact) }}
      </span>
      <span class="ops-dot" [ngClass]="'ops-dot--' + contact.status"></span>
    </span>

    <span class="ops-bubble ops-bubble--overflow" *ngIf="overflowCount">
      +{{ overflowCount }}
    </span>
  </button>

  <mat-menu
    #opsMenu="matMenu"
    [class]="'ops-presence-panel'"
    xPosition="before"
    [overlapTrigger]="false">
    <!-- Clicks inside the panel must not fall through to the trigger/backdrop. -->
    <div
      class="ops-panel"
      (click)="$event.stopPropagation()"
      (keydown)="onComposerKeydown($event)">
      <ng-container *ngIf="panelMode === 'roster'">
        <div class="ops-panel__head">
          <div class="ops-panel__title">Your ops team</div>
          <div class="ops-panel__subtitle">{{ availabilitySummary }}</div>
        </div>

        <div class="ops-panel__list">
          <div
            class="ops-row"
            *ngFor="let contact of contacts; trackBy: trackById">
            <span
              class="ops-bubble ops-bubble--lg"
              [class.ops-bubble--muted]="contact.status === 'off'">
              <img
                *ngIf="contact.avatarUrl"
                class="ops-bubble__img"
                [appAvatarImage]="contact.avatarUrl"
                [src]="contact.avatarUrl"
                [alt]="contact.name" />
              <span *ngIf="!contact.avatarUrl" class="ops-bubble__initials">
                {{ initials(contact) }}
              </span>
              <span
                class="ops-dot"
                [ngClass]="'ops-dot--' + contact.status"></span>
            </span>

            <div class="ops-row__body">
              <div class="ops-row__name">
                {{ contact.name }}
                <span
                  class="ops-status"
                  [ngClass]="'ops-status--' + contact.status">
                  {{ statusLabel(contact.status) }}
                </span>
              </div>
              <div class="ops-row__role">{{ contact.role }}</div>
              <a
                class="ops-row__email"
                [href]="'mailto:' + contact.email"
                (click)="$event.stopPropagation()"
                >{{ contact.email }}</a
              >
              <div class="ops-row__hours">
                {{ contact.officeHours.days }} ·
                {{ contact.officeHours.timezone }}
              </div>
            </div>
          </div>
        </div>

        <div class="ops-panel__foot">
          <button
            type="button"
            class="ops-btn ops-btn--primary"
            [disabled]="!gpId || !vehicleId"
            (click)="startCompose()">
            <mat-icon>chat_bubble_outline</mat-icon>
            Message team
          </button>
        </div>
      </ng-container>

      <!-- Composer: posts into the fund's Ops thread without leaving the page. -->
      <ng-container *ngIf="panelMode === 'compose'">
        <div class="ops-panel__head ops-panel__head--compose">
          <button
            type="button"
            class="ops-back"
            aria-label="Back to ops team"
            (click)="cancelCompose()">
            <mat-icon>arrow_back</mat-icon>
          </button>
          <div>
            <div class="ops-panel__title">Message Ops</div>
            <div class="ops-panel__subtitle">
              Goes to your fund's Ops thread
            </div>
          </div>
        </div>

        <div class="ops-panel__compose">
          <textarea
            class="ops-textarea"
            rows="4"
            placeholder="What do you need from Ops?"
            [(ngModel)]="draft"
            [disabled]="isSending"></textarea>
          <p class="ops-error" *ngIf="sendError">{{ sendError }}</p>
        </div>

        <div class="ops-panel__foot ops-panel__foot--actions">
          <button
            type="button"
            class="ops-btn ops-btn--ghost"
            *ngIf="sendError"
            (click)="openSupportChat()">
            Open chat
          </button>
          <button
            type="button"
            class="ops-btn ops-btn--ghost"
            *ngIf="!sendError"
            (click)="cancelCompose()"
            [disabled]="isSending">
            Cancel
          </button>
          <button
            type="button"
            class="ops-btn ops-btn--primary"
            (click)="send()"
            [disabled]="isSending || !draft.trim()">
            {{ isSending ? 'Sending…' : 'Send' }}
          </button>
        </div>
      </ng-container>

      <!-- Sent: the reply lands in the chat, so point the way there. -->
      <ng-container *ngIf="panelMode === 'sent'">
        <div class="ops-sent">
          <div class="ops-sent__mark"><mat-icon>check</mat-icon></div>
          <div class="ops-sent__title">Message sent to Ops</div>
          <div class="ops-sent__note">
            <ng-container *ngIf="sentChat?.supportTicketNumber">
              Ticket #{{ sentChat?.supportTicketNumber }} ·
            </ng-container>
            Replies arrive in your chat
          </div>
        </div>

        <div class="ops-panel__foot ops-panel__foot--actions">
          <button
            type="button"
            class="ops-btn ops-btn--ghost"
            (click)="menuTrigger?.closeMenu()">
            Done
          </button>
          <button
            type="button"
            class="ops-btn ops-btn--primary"
            (click)="openSentChat()">
            Open in chat
          </button>
        </div>
      </ng-container>
    </div>
  </mat-menu>
</div>
